<template>
  <div class="drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">{{ title }}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }}</li>
            </ol>
        </div>
    </div>

    <div class="col-12 text-left">
      <h6 class="text-danger" v-if="non_field_errors">{{ non_field_errors }}</h6>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form v-on:submit.prevent class="form-material">

              <div class="row" style="padding: 15px;">
                <div class="col-md-8 col-lg-8 m-2 p-0">
                  <label class="search-label">Pickup Address</label>
                  <input type="text" placeholder="default_pickup_address" v-model="default_pickup_address"
                        class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.default_pickup_address }}</div>
                </div>
                <div class="col-md-2 col-lg-2 m-2 p-0">
                  <label class="search-label">Pickup Latitude</label>
                  <input type="text" placeholder="default_pickup_latitude" v-model="default_pickup_latitude"
                        class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.default_pickup_latitude }}</div>
                </div>
                <div class="col-md-2 col-lg-2 m-2 p-0">
                  <label class="search-label">Pickup Longitude</label>
                  <input type="text" placeholder="default_pickup_longitude" v-model="default_pickup_longitude"
                        class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.default_pickup_longitude }}</div>
                </div>



                <div class="col-md-8 col-lg-8 m-2 p-0">
                  <label class="search-label">Dropoff Address</label>
                  <input type="text" placeholder="default_dropoff_address" v-model="default_dropoff_address"
                        class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.default_dropoff_address }}</div>
                </div>
                <div class="col-md-2 col-lg-2 m-2 p-0">
                  <label class="search-label">Dropoff Latitude</label>
                  <input type="text" placeholder="default_dropoff_latitude" v-model="default_dropoff_latitude"
                        class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.default_dropoff_latitude }}</div>
                </div>
                <div class="col-md-2 col-lg-2 m-2 p-0">
                  <label class="search-label">Dropoff Longitude</label>
                  <input type="text" placeholder="default_dropoff_longitude" v-model="default_dropoff_longitude"
                        class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.default_dropoff_longitude }}</div>
                </div>


                <div class="col-md-2 col-lg-3 m-2 p-0 form-ddown">
                  <label class="search-label">Pickup Date</label>
                  <VueCtkDateTimePicker v-model="date_pickup" format="YYYY-MM-DD HH:mm:ss" label="Pickup Date" class="date-pickup"/>
                  <div v-if="errors"  class="text-danger">{{ errors.date_pickup }}</div>
                </div>

                <div class="col-md-1 col-lg-2 m-2 p-0">
                  <label class="search-label">Local Timezone</label>
                  <input type="text" class="form-control" v-model="local_timezone"/>
                </div>

                <div class="col-md-1 col-lg-2 m-2 p-0">
                  <label class="search-label">Amount of Riders</label>
                  <input type="text" placeholder="amount_riders" v-model="amount_riders" class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.amount_riders }}</div>
                </div>
                <div class="col-md-1 col-lg-2 m-2 p-0">
                  <label class="search-label">Distance</label>
                  <input type="text" placeholder="default_distance_p_to_d" v-model="default_distance_p_to_d"
                        class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.default_distance_p_to_d }}</div>
                </div>
                <div class="col-md-1 col-lg-2 m-2 p-0">
                  <label class="search-label">Duration</label>
                  <input type="text" placeholder="default_duration_p_to_d" v-model="default_duration_p_to_d"
                        class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.default_duration_p_to_d }}</div>
                </div>
                <div class="col-md-1 col-lg-2 m-2 p-0">
                  <label class="search-label">Price</label>
                  <input type="text" placeholder="price_total" v-model="price_total" class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.price_total }}</div>
                </div>


                <!--<div class="col-md-1 col-lg-1 m-0 p-0"></div>-->
                <!--<div class="col-md-6 col-lg-6 m-0 p-0"></div>-->
                <div class="col-md-1 col-lg-2 m-2 p-0">
                  <label class="search-label">Driver ID</label>
                  <input type="text" placeholder="id_driver" v-model="id_driver" class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.id_driver }}</div>
                </div>
                <!--<div class="col-md-1 col-lg-2 m-2 p-0">-->
                  <!--<label class="search-label">Rider Last Name</label>-->
                  <!--<input type="text" placeholder="last_name" v-model="last_name" class="form-control"/>-->
                  <!--<div v-if="errors" class="text-danger">{{ errors.last_name }}</div>-->
                <!--</div>-->
                <!--<div class="col-md-1 col-lg-2 m-2 p-0">-->
                  <!--<label class="search-label">Rider First Name</label>-->
                  <!--<input type="text" placeholder="first_name" v-model="first_name" class="form-control"/>-->
                  <!--<div v-if="errors" class="text-danger">{{ errors.first_name }}</div>-->
                <!--</div>-->
                <!--<div class="col-md-2 col-lg-2 m-2 p-0">-->
                  <!--<label class="search-label">Rider Phone Number</label>-->
                  <!--<input type="text" placeholder="contact_phone" v-model="contact_phone" class="form-control"/>-->
                  <!--<div v-if="errors" class="text-danger">{{ errors.contact_phone }}</div>-->
                <!--</div>-->
                <div class="col-md-3 col-lg-3 m-2 p-0">
                  <label class="search-label">Rider Email</label>
                  <select type="text" placeholder="contact_email" v-model="contact_email" class="form-control">
                    <option>hyu+rider@wingz.com</option>
                    <option>randywang+rider@wingz.com</option>
                    <option>cbaumbach+rider@wingz.com</option>
                    <option>avinh+rider@wingz.com</option>
                    <option>mcoleman+rider@wingz.com</option>
                    <option>jtorres+rider@wingz.com</option>
                    <option>bdinwiddie+rider@wingz.com</option>
                  </select>
                  <div v-if="errors" class="text-danger">{{ errors.contact_email }}</div>
                </div>

                <!--<div class="col-md-5 col-lg-5 m-0 p-0"></div>-->


                <div class="col-md-12 col-lg-12 m-2 p-0">
                  <label class="search-label">Instructions</label>
                  <input type="text" placeholder="instructions" v-model="instructions" class="form-control"/>
                  <div v-if="errors" class="text-danger">{{ errors.instructions }}</div>
                </div>
              </div>

              <div class="submit-button">
                <button v-on:click="buttonCreate()" class="btn btn-info waves-effect waves-light m-t-10" >Create</button>
              </div>

              <router-link v-if="id_ride" :to="'/rides/' + id_ride + '/'" style="font-size: 2rem;">
                {{ id_ride }}
              </router-link>

            </form>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import Vue from 'vue'

  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'CreateRide',
    data () {
      return {
        title: 'Create a ride',
        isLoading: false,
        errors: null,
        non_field_errors: null,
        id_ride: null,
        // default_pickup_address: 'Atlanta Intl. Airport',
        // default_pickup_latitude: 33.637549,
        // default_pickup_longitude: -84.420073,
        // default_dropoff_address: 'PJHX+9H Atlanta, Georgia',
        // default_dropoff_latitude: 33.728444,
        // default_dropoff_longitude: -84.351047,
        default_pickup_address: 'Nashville International Airport',
        default_pickup_latitude: 36.123261,
        default_pickup_longitude: -86.677399,
        default_dropoff_address: '624 4th Ave S, Nashville, TN 37210',
        default_dropoff_latitude: 36.153709,
        default_dropoff_longitude: -86.772193,
        date_pickup: null,
        amount_riders: 1,
        default_distance_p_to_d: 15,
        default_duration_p_to_d: 2400,
        price_total: 60,
        id_driver: null,
        first_name: 'Cheque',
        last_name: 'Yu',
        contact_phone: '+14085558190',
        contact_email: 'hyu+rider@wingz.com',
        instructions: 'Please pick me up on the side of the house',
        local_timezone: 'America/New_York',
      }
    },
    components: {
      Loading
    },
    methods: {
      buttonCreate: function () {
        this.reset()
        this.isLoading = true
        this.$http
          .post(process.env.API_BASE_URL_CS + 'rides/', {
            default_pickup_address: this.default_pickup_address,
            default_pickup_latitude: this.default_pickup_latitude,
            default_pickup_longitude: this.default_pickup_longitude,
            default_dropoff_address: this.default_dropoff_address,
            default_dropoff_latitude: this.default_dropoff_latitude,
            default_dropoff_longitude: this.default_dropoff_longitude,
            date_pickup: this.date_pickup,
            amount_riders: this.amount_riders,
            default_distance_p_to_d: this.default_distance_p_to_d,
            default_duration_p_to_d: this.default_duration_p_to_d,
            price_total: this.price_total,
            id_driver: this.id_driver,
            first_name: this.first_name,
            last_name: this.last_name,
            contact_phone: this.contact_phone,
            contact_email: this.contact_email,
            instructions: this.instructions,
            local_timezone: this.local_timezone,
            distribution_method: 'UNASSIGNED',
          })
          .then(response => {
            Vue.toasted.show('Success!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(response.data)
            this.id_ride = response.data.id_ride
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      reset: function () {
        this.errors = null
        this.non_field_errors = null
        this.id_ride = null
      }
    },
    mounted() {
      console.log(this.errors)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    /*position: fixed;*/
    /*bottom: 60px;*/
    /*right: 50%;*/
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CreateRide.vue